// ============================================================================
// BED
// ============================================================================

import CONFIG from '../config.js';

export class Bed {
    constructor(x, y, physics = null) {
        this.x = x;
        this.y = y;
        this.width = 120;
        this.height = 80;
        this.physics = physics;
        
        if (physics) {
            this.body = physics.createRectangle(x, y, this.width, this.height, {
                isStatic: true,
                frictionAir: 0,
                friction: 0,
                restitution: 0
            });
            physics.linkEntity(this, this.body);
        } else {
            this.body = null;
        }
    }
    
    update(dt) {
        if (this.body) {
            this.x = this.body.position.x;
            this.y = this.body.position.y;
        }
    }

    draw(ctx, camera) {
        ctx.save();

        const drawX = this.x;
        const drawY = this.y;

        // --- 3/4 PERSPECTIVE SETTINGS ---
        const depth = 12;
        const heightOffset = 30;

        const darkerColor = '#654321';
        const topColor = '#A0826D';
        const bedColor = CONFIG.colors.bed;

        // 1. Draw SIDE/THICKNESS
        ctx.fillStyle = darkerColor;
        ctx.fillRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, this.height + heightOffset);

        // 2. Draw TOP SURFACE
        ctx.fillStyle = topColor;
        ctx.fillRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, depth);
        ctx.strokeStyle = '#000';
        ctx.strokeRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, depth);

        // 3. Draw FRONT FACE
        const frontY = drawY - this.height / 2 - heightOffset + depth;
        const frontHeight = this.height + heightOffset - depth;

        // Bed frame
        ctx.fillStyle = bedColor;
        ctx.fillRect(drawX - this.width / 2, frontY, this.width, frontHeight);
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 2;
        ctx.strokeRect(drawX - this.width / 2, frontY, this.width, frontHeight);

        // Mattress (on front face)
        ctx.fillStyle = '#8B7355';
        ctx.fillRect(drawX - this.width / 2 + 3, frontY + 3, this.width - 6, frontHeight - 6);

        // Pillow (on top surface, visible from front)
        ctx.fillStyle = '#F5F5DC';
        ctx.fillRect(drawX - this.width / 2 + 10, frontY + 5, 30, 15);
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 1;
        ctx.strokeRect(drawX - this.width / 2 + 10, frontY + 5, 30, 15);

        ctx.restore();
    }
}
